import React from "react";
import "../../styles/desktop/textoMain.css";

const Header = () => {
  return (
    <div className="container">
      <h1 id="texto-main">
        Sistema de Automação Predial
      </h1>
    </div>
  );
};

export default Header;
